import { render, staticRenderFns } from "./RestrictionUpdate.vue?vue&type=template&id=0cef3867&scoped=true"
import script from "./RestrictionUpdate.vue?vue&type=script&lang=js"
export * from "./RestrictionUpdate.vue?vue&type=script&lang=js"
import style0 from "./RestrictionUpdate.vue?vue&type=style&index=0&id=0cef3867&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cef3867",
  null
  
)

export default component.exports